import { c as _c } from "react/compiler-runtime";
import { Checkbox, CheckboxProps } from '@systemeio/ui';
import { Controller, ControllerProps, FieldPath, FieldValues, PathValue, UseFormSetValue } from 'react-hook-form';
type CheckboxRhfProps<TValues extends FieldValues, TName extends FieldPath<TValues>> = Omit<CheckboxProps, 'onChange' | 'value'> & Omit<ControllerProps<TValues, TName>, 'render'> & {
  setValue: UseFormSetValue<TValues>;
  afterChange?: (value: boolean) => void;
};
function CheckboxRhf(props) {
  const $ = _c(19);
  let afterChange;
  let control;
  let name;
  let restProps;
  let rules;
  let setValue;
  if ($[0] !== props) {
    ({
      setValue,
      control,
      name,
      rules,
      afterChange,
      ...restProps
    } = props);
    $[0] = props;
    $[1] = afterChange;
    $[2] = control;
    $[3] = name;
    $[4] = restProps;
    $[5] = rules;
    $[6] = setValue;
  } else {
    afterChange = $[1];
    control = $[2];
    name = $[3];
    restProps = $[4];
    rules = $[5];
    setValue = $[6];
  }
  let t0;
  if ($[7] !== afterChange || $[8] !== name || $[9] !== setValue) {
    t0 = value => {
      setValue(name, value as PathValue<TValues, TName>);
      afterChange?.(value);
    };
    $[7] = afterChange;
    $[8] = name;
    $[9] = setValue;
    $[10] = t0;
  } else {
    t0 = $[10];
  }
  const handleChange = t0;
  let t1;
  if ($[11] !== handleChange || $[12] !== restProps) {
    t1 = t2 => {
      const {
        field
      } = t2;
      return <Checkbox {...restProps} value={field.value} onChange={handleChange} />;
    };
    $[11] = handleChange;
    $[12] = restProps;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  let t2;
  if ($[14] !== control || $[15] !== name || $[16] !== rules || $[17] !== t1) {
    t2 = <Controller control={control} name={name} rules={rules} render={t1} />;
    $[14] = control;
    $[15] = name;
    $[16] = rules;
    $[17] = t1;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  return t2;
}
export default CheckboxRhf;